import ListItemComponent from './ListItem';
import {
    ContentElement,
    IconElement,
    LeftContentElement,
    PrimaryTextElement,
    RightContentElement,
    SecondaryTextElement,
} from './style';

/**
 * @deprecated use DropdownItem instead.
 * Select and DropdownButton components are being migrated to DropdownItem since Nov. 24, 2024.
 * Rest of usages of ListItem will be migrated to DropdownItem in next months.
 * Contact Design System team for more information.
 */
export const ListItem = Object.assign(ListItemComponent, {
    ContentElement,
    IconElement,
    LeftContentElement,
    PrimaryTextElement,
    SecondaryTextElement,
    RightContentElement,
});

export { ListItemContainerElement } from './style';
export { listItemFactory } from './ListItem';
export type { ListItemProps } from './ListItem';
